import React, { useState, useEffect } from 'react'
import { Tag, Tooltip } from 'antd'

const RenderTime = ({ processingAt, colorMerge, mergeFileStatus, mergeFileJob }) => {
    const [formattedTime, setFormattedTime] = useState({})
    const [hovering, setHovering] = useState(false)

    const timeRender = () => {
        const { processing_at, error_message } = mergeFileJob
        const processTime = new Date(processing_at)
        const endTime = new Date()

        switch (mergeFileStatus) {
            case 'processing':
                return {
                    processingTime: calculateTime(endTime - processTime).trim()
                }
            case 'error':
                return { error: error_message }
            default:
                return {}
        }
    }

    const calculateTime = (time) => {
        if (!time) return ''

        const hours = Math.floor(time / (1000 * 60 * 60))
        const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((time % (1000 * 60)) / 1000)

        return `${!!hours ? String(hours).padStart(2, '0') + 'h' : ''} ${!!minutes ? String(minutes).padStart(2, '0') + 'm' : ''} ${!!seconds ? String(seconds).padStart(2, '0') + 's' : ''}`
    }

    const content = () => {
        const { processingTime = '', error = '' } = formattedTime
        if (!!error) return <span>{error}</span>

        return (
            <>
                {!!processingTime && <div>Thời gian xử lý: {processingTime}</div>}
            </>
        )
    }

    useEffect(() => {
        if (hovering) {
            setFormattedTime(timeRender())
        }
    }, [hovering, processingAt])

    return (
        (['processing', 'error'].includes(mergeFileStatus)) ?
            <Tooltip
                title={content()}
                placement='topLeft'
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
            >
                <span className={`badge cursor-pointer ${colorMerge} badge-pill`}>{mergeFileStatus}</span>
            </Tooltip> :
            <span className={`badge cursor-pointer ${colorMerge} badge-pill`}>{mergeFileStatus}</span>
    )
}

export default RenderTime